<template>
  <div class="main">
   <div class="x-subnav">
      <xy-toolbox-menu class="l" :items="equipMenu" current="装备表"  />
          <xy-toolbox-menu class="r" v-show="!viewResult">
              <xy-toolbox-menu-item custom>  </xy-toolbox-menu-item>
          </xy-toolbox-menu>
          <div  class="r action-btn-box" v-show="!viewResult">
           <el-button @click="queryData" type="primary"  :disabled="searchResult.length==0"  class="actionBtn"  round >车款装备数据  <svg-icon name="play" size="12" ></svg-icon> </el-button> 
          </div>
      <xy-toolbox-menu class="r" v-show="viewResult">
        <xy-toolbox-menu-item icon="car_search" @click="chooseCars" >返回</xy-toolbox-menu-item>
        <xy-toolbox-menu-item icon="excel" @click="exportExcel">Excel导出  </xy-toolbox-menu-item>
      </xy-toolbox-menu>
    </div>
    <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
      <el-button @click="queryData" type="primary" v-if="false">车款装备数据</el-button>
    </SearchBar>
    <div v-if="viewResult" class="view-main">
      <xy-toolbox-menu>
        <xy-toolbox-menu-item custom>
          <div class="custom-content">
            <el-select
              v-model="viewValue"
              placeholder="选择装备显示形式"
              @change="changeViewOption"
            >
              <el-option
                v-for="item in viewOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </xy-toolbox-menu-item>
 
      </xy-toolbox-menu>
      <div></div>
      <el-row>
        <el-col :span="4">
          <el-checkbox
            :indeterminate="isIndeterminate"
            v-model="checkAll"
            @change="handleCheckAllChange"
            >全选</el-checkbox
          >
        </el-col>
        <el-col :span="20" style="text-align: left">
          <el-checkbox-group
            v-model="checked_attr"
            @change="handleCheckedChange"
          >
            <el-checkbox v-for="cat in categories" :label="cat" :key="cat">{{
              cat
            }}</el-checkbox>
          </el-checkbox-group>
        </el-col>
      </el-row>
      <div style="width: 80%; margin: 0 auto">
        <ul class="line-nav" id="nav-fixed" :class="{ nav_fixed: isFixed }">
          <li id="first">
            <el-link icon="el-icon-more" @click="displayCars">选择车款</el-link>
          </li>
          <li v-for="item in displayLines" :label="item.name" :key="item.id">
            <div class="title" :title="item.name">
              <el-link icon="el-icon-remove" @click="removeCar(item.id)">
              </el-link
              >{{ item.name }}
            </div>
          </li>
        </ul>
        <ul class="line-nav" style="margin-top: -11px">
          <li id="first"></li>
          <li v-for="item in displayLines" :label="item.name" :key="item.id">
            <el-tag type="Success" size="mini">MSRP:{{ item.msrp }}</el-tag>
            &nbsp;
            <el-tag type="Success" size="mini">Price:{{ item.price }}</el-tag>
          </li>
        </ul>
        <div id="equipdata">
          <el-collapse v-model="activeNames">
            <el-collapse-item
              :name="i"
              :key="i"
              v-for="i in categories"
              v-show="checkCategory(i)"
            >
              <template slot="title"
                ><h3 class="cat-title">{{ i }}</h3></template
              >
              <div
                class="row"
                :name="j.id"
                :key="j.id"
                v-for="j in getParams(i)"
                v-show="checkShow(j)"
              >
                <div class="col tl">{{ j.name }}</div>
                <div
                  class="col"
                  :name="k.id"
                  :key="k.id"
                  v-for="k in displayLines"
                  v-html="showLabel(j.name, j.lines[k.id])"
                ></div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <el-dialog
      width="500px"
      :close-on-click-modal="false"
      :visible.sync="viewDisplayCars"
      :before-close="hideDisplayCars"
      :center="false"
      :show-close="true"
      :append-to-body="true"
    >
      <span class="dialog-title clearfix" slot="title">
        <span>选择显示车款</span>
      </span>

      <div class="body">
        <ul class="ea-carlist">
          <li v-for="c in lines" :key="c.id" :name="c.id">
            <el-checkbox
              :label="c.name"
              :key="c.id"
              @change="changeDisplayCar(c.id, this)"
              :checked="carIsChecked(c.id)"
            ></el-checkbox>
          </li>
        </ul>
      </div>
    </el-dialog>
  </div>
</template>


<script>
const MaxShowLength = 4;
const OptionPattern = /\(选装:\s?(?:[^()])*(\([^()]*\)[^()]*)*\)/g;
import { mapMutations, mapGetters, mapActions } from "vuex";
import SearchBar from "@/components/common/NewSearchBar.vue";
import Permissions from "@/store/permissions.js";
import { formatDate, strToFormatDate } from "@/plugins/DateTimeFormater.js";
export default {
  name: "equipnalysis",
  components: {
    SearchBar,
  },
  data() {
    return {
      tableCfg: null,
      viewResult: false,
      viewValue: 1,
      viewDisplayCars: false,
      currentModuleName: "EquipAnalysis",
      viewOptions: [
        {
          value: 1,
          label: "显示全部装备",
        },
        {
          value: 2,
          label: "仅显示差导装备",
        },
        {
          value: 3,
          label: "仅显示相同装备",
        },
        {
          value: 4,
          label: "隐藏空白装备",
        },
      ],
      checkAll: false,
      catagories: [],
      checked_attr: [],
      isIndeterminate: false,
      tableData: [],
      lines: [],
      displayLines: [],
      categoriesOptions: [],
      categorySort: [
        "智能网联",
        "科技",
        "安全",
        "外饰",
        "内饰",
        "钥匙",
        "参数",
        "动力",
        "底盘",
      ],
      activeNames: [],
      paramData: [],
      isFixed: false,
      offsetTop: 0,
    };
  },
  methods: {
    ...mapActions("equipanalysis", ["queryEquipParams"]),
    handleScroll() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop >= this.offsetTop) {
        this.isFixed = true;
      } else {
        this.isFixed = false;
      }
    },
    setViewResult(isShow) {
      this.viewResult = isShow;
      if (this.viewResult) {
        this.offsetTop = 200; //document.querySelector('#nav-fixed').offsetTop;
        // 开启滚动监听
        window.addEventListener("scroll", this.handleScroll);
      }
    },
    removeCar(id) {
      this.displayLines.splice(
        this.displayLines.findIndex((x) => x.id == id),
        1
      );
      this.lines.splice(
        this.lines.findIndex((x) => x.id == id),
        1
      );
      //  this.paramData.lines.splice(this.paramData.lines.findIndex(x => x.id == id), 1);
      this.paramData.forEach((x) => {
        delete x.lines[id];
      });
    },
    changeDisplayCar(id) {
      if (this.displayLines.findIndex((x) => x.id == id) > -1) {
        this.displayLines.splice(
          this.displayLines.findIndex((v) => v.id == id),
          1
        );
      } else {
        if (this.displayLines.length + 1 > MaxShowLength) {
          this.$message({
            message: "最多只展示" + MaxShowLength + "款车",
            duration: 2000,
          });
        }
        var item = this.lines.find((x) => x.id == id);
        this.displayLines.push(item);
      }
    },
    queryData() {
      var ids = this.searchResult.map((item) => {
        return parseInt(item.id);
      });
      var postData = {
        ids: ids,
      };
      this.queryEquipParams({
        params: postData,
        handle: this.setViewResult,
      });
    },
    exportExcel() {
      if (!Permissions.Client_ViewLine_EqData_Down()) {
        this.$message({ message: "没有下载权限。", duration: 2000 });
        return;
      }
      var excelData = [];
      var optData = [];
      var msrpRow = {
        装备大类: "价格",
        装备名称: "MSRP",
      };
      var priceRow = {
        装备大类: "价格",
        装备名称: "Price",
      };
      for (var item of this.lines) {
        // for (var lineId in this.paramData[0].lines) {
        //    var item = this.lines.find(x => x.id == lineId);
        msrpRow[item.name] = item.msrp;
        priceRow[item.name] = item.price;
      }
      excelData.push(msrpRow);
      excelData.push(priceRow);
      for (const cat of this.categories) {
        for (var i = 0; i < this.paramData.length; i++) {
          var r = this.paramData[i];
          if (cat != r.tag) {
            continue;
          }
          if (!this.checkCategory(cat)) {
            continue;
          }
          // if(r.tag=='参数' || r.tag=='动力')
          // {
          //    continue;
          // }
          var tmpLine = {
            装备大类: r.tag,
            装备名称: r.name,
          };
          var optLine = {
            装备大类: "选配",
            装备名称: r.name,
          };
          var hasOption = false;
          for (var item of this.lines) {
            var j = item.id;

            if (r.lines[j] && r.lines[j].trim() == r.name.trim()) {
              tmpLine[item.name] = "S";
              optLine[item.name] = "-";
            } else {
              var val = r.lines[j];
              if (val) {
                val = val.replace("（", "(").replace("）", ")");
              }

              if (!val || val == "") {
                tmpLine[item.name] = "-";
                optLine[item.name] = "-";
              } else if (item.name == "上市日期") {
                val = strToFormatDate(val);
                tmpLine[item.name] = val;
                optLine[item.name] = "-";
              } else if (val.trim() == item.name) {
                tmpLine[item.name] = "S";
                optLine[item.name] = "-";
              } else if (OptionPattern.test(val)) {
                var remain = val.replace(OptionPattern, "");
                if (remain == "") {
                  tmpLine[item.name] = "-";
                } else {
                  tmpLine[item.name] = remain;
                }

                // var arr = OptionPattern.exec(val);
                // //alert(arr.length);
                // //循环输出结果
                // for (var z = 0; z < arr.length; z++) {
                //    optLine[item.name] += arr[z];
                // }
                optLine[item.name] = val.replace(remain, "");
                hasOption = true;
              } else {
                tmpLine[item.name] = val.trim();
                optLine[item.name] = "-";
              }
            }
          }
          if (hasOption) {
            optData.push(optLine);
          }
          excelData.push(tmpLine);
        }
      }
      for (var x of optData) {
        excelData.push(x);
      }
      //alert(JSON.stringify(optData));
      JSONToExcel(excelData, "装备", "equip");
    },
    chooseCars() {
      this.viewResult = false;
    },
    displayCars() {
      this.viewDisplayCars = true;
    },
    hideDisplayCars() {
      this.viewDisplayCars = false;
    },
    handleCheckAllChange(val) {
      this.checked_attr = val ? this.categories : [];
      this.isIndeterminate = false;
    },
    changeViewOption(val) {
      //  this.bindTable();
    },
    handleCheckedChange(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.catagories.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.catagories.length;
    },
    bindTable() {
      this.displayLines = [];
      this.categoriesOptions = this.equipParamsList.categories;
      this.categories = this.categoriesOptions.map((x) => x.name);
      this.categories.sort((prev, next) => {
        return (
          this.categorySort.indexOf(prev) - this.categorySort.indexOf(next)
        );
      });
      this.lines = this.equipParamsList.lines;
      this.paramData = this.equipParamsList.dataDict;
      this.activeNames = [...this.categories];
      this.checked_attr = this.categories;
      for (var i = 0; i < this.lines.length; i++) {
        if (i < MaxShowLength) {
          this.displayLines.push(this.lines[i]);
        }
      }
    },
  },
  computed: {
    ...mapGetters("equipanalysis", {
      equipParamsList: "equipParamsList",
    }),
    ...mapGetters("commonsearch", {
      searchResult: "selectionResult",
      savedResultSchemas: "savedResultSchemas",
      pivotTableKey: "pivotTableKey",
      showSubmodel: "showSelectionSubmodel",
    }),
    dragOptions() {
      return {
        animation: 0,
        group: "description",
      };
    },
    getParams() {
      return function (category) {
        return this.paramData.filter((item) => {
          return item.tag == category;
        });
      };
    },
    //检查显示条件
    checkShow() {
      return function (j) {
        var v = this.viewValue; //显示类型
        if (v == 1) {
          return true;
        } else if (v == 2) {
          const evNums = new Set();
          this.lines.forEach((el) => {
            evNums.add(j.lines[el.id]);
          });
          return evNums.size > 1;
        } else if (v == 3) {
          const evNums = new Set();
          this.lines.forEach((el) => {
            evNums.add(j.lines[el.id]);
          });
          return evNums.size == 1;
        } else if (v == 4) {
          const evNums = new Set();
          this.lines.forEach((el) => {
            evNums.add(j.lines[el.id]);
          });
          if (evNums.size == 1 && evNums.has("-")) return false;
          if (evNums.size == 1 && evNums.has("")) return false;
        }
        return true;
      };
    },
    showLabel() {
      return function (name, value) {
        if (name == "上市日期") {
          return (
            "<span class='attr-value'>" + strToFormatDate(value) + "</span>"
          );
        }
        if (!value) return "<span class='attr-none'>-</span>";
        if (value.trim() == name) return "<span class='attr-s'>S</span>";
        if (value == "") return "<span class='attr-value'>-</span>";
        return "<span class='attr-value'>" + value + "</span>";
      };
    },
    checkCategory() {
      return function (i) {
        return this.checked_attr.findIndex((x) => x == i) > -1;
      };
    },
    carIsChecked() {
      return function (id) {
        return this.displayLines.findIndex((x) => x.id == id) > -1;
      };
    },
  },
  watch: {
    viewResult(value) {},
    equipParamsList(value) {
      this.bindTable();
    },
  },
  mounted() {
    this.$nextTick(() => {});
  },
  created(){

     var ids=this.$route.query.ids;
  
     if(ids&&ids.length>0){
      this.viewResult = true;

    var postData = {
    ids: eval(ids),
  };
  this.queryEquipParams({
    params: postData,
    handle: this.setViewResult,
  });
     }
     
     
  },
  destroyed() {
    // 离开页面 关闭监听 不然会报错
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>
 <style   scoped>
#nav-fixed {
  background: rgba(255, 255, 255, 0.8);
}

.nav_fixed {
  position: fixed;
  z-index: 2;
  top: 0;
  width: 77.2%;
  margin-top: 0;
  border-left: none;
  border-right: none;
}
.actionBtn{
  margin-top:20px; position: absolute; right:72px;
}
</style>
